import { ResultPage } from 'runtime/data/resultpage';
import { WorkflowInstanceInfo } from 'runtime/data/workflowinstanceinfo';

export class WorkflowInstanceInfoPage extends ResultPage<WorkflowInstanceInfo> { }